import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import Required from '@util/decorators/required';
import {UUID} from '@util/types';
import {Subject} from 'rxjs';
import {switchMap} from 'rxjs/operators';
import {VoilaUserService} from '@services/voila-user.service';
import {ProductService} from '@services/product.service';
import {isSome} from 'fp-ts/lib/Option';
import {MatButtonModule} from '@angular/material/button';
import {OrderSampleComponent} from '@app/product-view/order-sample/order-sample.component';
import {CommonModule} from '@angular/common';

export interface OrderSampleData {
  productId: UUID;
}
@Component({
  selector: 'app-order-sample-button',
  templateUrl: './order-sample-button.component.html',
  styleUrls: ['./order-sample-button.component.scss'],
  standalone: true,
  imports: [CommonModule, MatButtonModule, OrderSampleComponent],
})
export class OrderSampleButtonComponent implements OnInit, OnChanges {
  @Required @Input() productId: UUID;

  productId$: Subject<UUID> = new Subject();

  sampleRequested: boolean | null = null;

  constructor(
    readonly userService: VoilaUserService,
    private readonly productService: ProductService,
  ) {}

  ngOnInit() {
    /* get sample request */
    this.productId$
      .pipe(
        switchMap((productId) => {
          return this.productService.getSampleRequest(productId, this.userService.currentUser().companyId);
        }),
      )
      .subscribe((sampleRequest) => {
        this.sampleRequested = isSome(sampleRequest);
      });

    this.productId$.next(this.productId);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.productId) {
      this.productId$.next(changes.productId.currentValue);
    }
  }

  canOrderSample(): boolean {
    if (this.userService.currentUser().userType == 'MA' && this.userService.currentUser().userPrivilege == 'FULL') {
      return true;
    }
    return this.userService.currentUser().userType == 'HP';
  }
}
